import React from "react";
import AdmissionsPage from "./AdmissionsPage";

const Admissions = () => {
  return <AdmissionsPage />;
};

export default Admissions;
